import * as React from 'react'
import { useHistory } from 'react-router-dom'
import { useAmazonBookSearchBase } from './useAmazonBookSearchBase'
import { BookResult, SortDecision } from '../types'

interface BookData {
  title?: string
  author?: string
  isbn?: string
  language?: string
  publisher?: string
  category?: string
  imageUrl?: string
  asin?: string
  listingPrice?: number
  shippingPrice?: number
  packageWeight?: number
  salesRank?: number
  length?: number
  width?: number
  height?: number
  weight?: number
  highestSalesRankCategory?: string
  classifications?: {
    classificationId: string
    displayName: string
  }
}

export const useAmazonBookSearchWithNavigation = () => {
  const history = useHistory()

  const handleSortDecisionChange = React.useCallback(
    (decision: SortDecision, selectedBook: BookResult | null, _selectedIndex: number | null) => {
      if (decision === 'ecommerce' && selectedBook) {
        const bookData: BookData = {
          title: selectedBook.title,
          author: selectedBook.author,
          publisher: selectedBook.publisher,
          isbn: selectedBook.isbn,
          imageUrl: selectedBook.mainImageUrl,
          asin: selectedBook.asin,
          listingPrice: selectedBook.listingPrice,
          shippingPrice: selectedBook.shippingPrice,
          packageWeight: selectedBook.packageWeight,
          salesRank: selectedBook.salesRank,
          weight: selectedBook.packageWeight,
          length: selectedBook.packageLength,
          width: selectedBook.packageWidth,
          height: selectedBook.packageHeight,
          highestSalesRankCategory: selectedBook.highestSalesRankCategory,
          classifications: selectedBook.classifications
        }

        setTimeout(() => {
          history.push('/scan-to-list-books/new-listing', { bookData })
        }, 1000)
      }
    },
    [history]
  )

  return useAmazonBookSearchBase({
    initialSortDecision: 'none',
    onSortDecisionChange: handleSortDecisionChange
  })
}
